<template>
  <div>
    <custom-dialog width="700px" :showClose="true" title="项目详情" v-if="visibleObj.executeDetail"
      :visible="visibleObj.executeDetail" @close="dialogVisible('executeDetail')">
      <div slot="content" class="executeDetail-warp">
        <div class="executeDetail-title">理疗项目：{{ physioName }}</div>
        <div class="table">
          <customTable max-height="484" :tableData="tableData" :showPages="false" :column="column"
            :header-cell-style="{ background: '#F0F1F3' }">
            <template slot="action" slot-scope="row">
              <el-button type="text" @click="print(row.row)">打印执行单</el-button>
            </template>
          </customTable>
        </div>
      </div>
      <div class="btn-warp" slot="footer">
        <custom-button type="primary" size="medium" @click="dialogVisible('executeDetail')">关闭</custom-button>
      </div>
    </custom-dialog>
    <!-- 打印 -->
    <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow"
      @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
      @printSuccess="printSuccess" :id="printOrderId" :orderType="14" :printType="5">
    </printDialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import customTable from '@/components/customTable/customTable'
import { drugDTO } from '@/DTO/index'
import { isNull } from '../../../../utils/validateBase'
import printDialog from '@/components/printDialog'
export default {
  // 定义引入的组件
  components: { CustomDialog, customTable, printDialog },
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      physioName: '',
      tableData: [],
      column: [
        { label: "执行时间", prop: "executeStartTime", align: 'left', },
        { label: "执行人", prop: "userName", align: 'left', },
        { label: "执行次数", prop: "executeNum", align: 'left', formatter:(row=>{
          if(!isNull(row.physioExtendJson)){
            let  { executionMode,onlyNum} = row.physioExtendJson
            return executionMode ==20 ? row.executeNum / onlyNum : row.executeNum;
          }else{
            return row.executeNum;
          }
        })},
        { label: "操作", prop: "orderNum", slotName: "action", },
      ],
      printDialogShow: false,//打印弹框
      printOrderId: '',//打印id
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() {
    this.getDetail()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * 获取详情
     */
    async getDetail() {
      let { ctOrderId, physioId } = this.dialogObj
      let { code, data } = await drugDTO.recordRecipe({ ctOrderId, physioId })
      if (code == 200) {
        this.tableData = data
      }
    },
    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    //打印
    print(row) {
      this.printOrderId = row.batchNo
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.printDia.useDefaultPrint()
      })
    },
    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 打印完成
     */
    printSuccess() {
      // this.dialogVisible('executePrintDialog', false)
      this.$message.success('打印成功')
      this.$emit("close", 'executeDetail');
    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
  },
}
</script>
<style lang="less" scoped>
.executeDetail-warp {
  font-size: 14px;

  .executeDetail-title {
    color: #1F2329;
    font-weight: 500;
  }

  .table {
    border: 1px solid #D3D3D5;
    border-bottom: none;
    border-radius: 2px;
    margin-top: 8px;
  }
}

.btn-warp {
  padding-bottom: 16px;
  padding-right: 24px;
  text-align: right;
  margin-top: 12px;
}
</style>